module.exports = __webpack_public_path__ + "static/media/header-background.64a6a698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/header-background.png
// module id = 386
// module chunks = 0